
import { supabase } from "@/integrations/supabase/client";
import { CallTranscript } from "@/types";
import { Tables } from "@/integrations/supabase/types";

// Create a call transcript
export const createCallTranscript = async (transcript: Omit<CallTranscript, "id" | "created_at">): Promise<Tables<"call_transcripts">> => {
  const { data, error } = await supabase
    .from("call_transcripts")
    .insert(transcript)
    .select()
    .single();

  if (error) throw error;
  return data;
};

// Get call transcript for a lead
export const getCallTranscriptByLeadId = async (leadId: string): Promise<Tables<"call_transcripts"> | null> => {
  const { data, error } = await supabase
    .from("call_transcripts")
    .select("*")
    .eq("lead_id", leadId)
    .maybeSingle();

  if (error) throw error;
  return data;
};

// Save a call transcript from an audio URL
export const transcribeCall = async (leadId: string, audioUrl: string): Promise<CallTranscript> => {
  try {
    console.log(`Transcribing call for lead ID: ${leadId}`);
    
    // Call Whisper API via edge function to transcribe the audio
    const { data, error } = await supabase.functions.invoke("transcribe-call", {
      body: { audioUrl },
    });

    if (error) throw error;
    if (!data.success) throw new Error(data.error || "Failed to transcribe call");

    // Create the call transcript in the database
    const callTranscript: Omit<CallTranscript, "id" | "created_at"> = {
      lead_id: leadId,
      audio_url: audioUrl || "https://example.com/fallback-audio.mp3", // Ensure this is never undefined
      transcript: data.transcript
    };

    return await createCallTranscript(callTranscript) as CallTranscript;
  } catch (error) {
    console.error("Error transcribing call:", error);
    // Create a basic transcript if transcription fails
    const fallbackTranscript: Omit<CallTranscript, "id" | "created_at"> = {
      lead_id: leadId,
      audio_url: audioUrl || "https://example.com/fallback-audio.mp3", // Ensure this is never undefined
      transcript: "Transcription unavailable"
    };
    return await createCallTranscript(fallbackTranscript) as CallTranscript;
  }
};
